import React from 'react'
import _ from 'lodash'
import { connect, ConnectedProps } from 'react-redux'

import lang from 'lang'
import { changeModal } from 'services/actions'
import DistrictForm from 'page-modules/dashboard/district-form'
import { AppState } from 'common/store/reducer'

interface OwnProps {
  submitDistrict: (data: Record<string, unknown>) => void
}

const connector = connect(
  (state: AppState) => ({
    user: state.root.user,
    districtFormData: state.manageDistrict.form.formData,
    loading: state.manageDistrict.request.post.loading || state.district.details.loading,
  }),
  (dispatch) => ({
    changeModal: (params: Parameters<typeof changeModal>[0]) => dispatch(changeModal(params)),
  }),
)

type Props = ConnectedProps<typeof connector> & OwnProps
type DistrictFormProps = { districtName?: string }
const DistrictFormComponent = DistrictForm as unknown as React.ComponentType<DistrictFormProps>

class DistrictFormModal extends React.Component<Props> {
  closeModal = (): void => {
    this.props.changeModal({ isOpen: false })
  }

  handleSaveClick = (): (() => void) => {
    return () => {
      const formData = this.props.districtFormData as Record<string, unknown> & {
        started_ruler?: boolean
      }
      const validations = (DistrictForm as unknown as { validations?: Record<string, string> })
        .validations
      const schoolData = _.mapValues(formData, (value, key) => ({
        value,
        validations:
          key === 'started_ruler_at' && !formData.started_ruler ? '' : validations?.[key],
      }))
      this.props.submitDistrict(schoolData)
    }
  }

  render(): React.ReactNode {
    const formData = this.props.districtFormData as { id?: string; name?: string }
    return (
      <div className="modal-wrapper">
        <div className="modal-header">
          <h2 id="add-new-district-header">
            {formData.id
              ? lang.dashboard.districtForm.updateTitle
              : lang.dashboard.districtForm.addTitle}
          </h2>
        </div>
        <div className="modal-container">
          <DistrictFormComponent districtName={formData.name} />
        </div>
        <div className="modal-footer">
          <div className="modal-button-wrapper">
            <button
              type="button"
              className="button save"
              disabled={this.props.loading}
              onClick={this.handleSaveClick()}>
              {lang.saveButton}
            </button>
            <button type="button" className="button clear cancel" onClick={() => this.closeModal()}>
              {lang.cancelButton}
            </button>
          </div>
        </div>
      </div>
    )
  }
}

export default connector(DistrictFormModal)
